/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OpenLot } from './OpenLot';
import {
    OpenLotFromJSON,
    OpenLotFromJSONTyped,
    OpenLotToJSON,
} from './OpenLot';

/**
 * 
 * @export
 * @interface OpenLotsPage
 */
export interface OpenLotsPage {
    /**
     * 
     * @type {Array<OpenLot>}
     * @memberof OpenLotsPage
     */
    lots: Array<OpenLot>;
    /**
     * 
     * @type {number}
     * @memberof OpenLotsPage
     */
    totalNr: number;
    /**
     * 
     * @type {string}
     * @memberof OpenLotsPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the OpenLotsPage interface.
 */
export function instanceOfOpenLotsPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lots" in value;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function OpenLotsPageFromJSON(json: any): OpenLotsPage {
    return OpenLotsPageFromJSONTyped(json, false);
}

export function OpenLotsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenLotsPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lots': ((json['lots'] as Array<any>).map(OpenLotFromJSON)),
        'totalNr': json['total_nr'],
        'asOfDate': json['as_of_date'],
    };
}

export function OpenLotsPageToJSON(value?: OpenLotsPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lots': ((value.lots as Array<any>).map(OpenLotToJSON)),
        'total_nr': value.totalNr,
        'as_of_date': value.asOfDate,
    };
}

